export default __webpack_public_path__ + "static/media/user-grid.4146124c.svg";